import React, { useState } from "react";
import "./Contact.css";
import MineThunderlogo from "../../assets/MineThunderLogoBlackText.png";
import axios from "axios"; // Import Axios

export default function ContactUs() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    businessName: "",
    email: "",
    subject: "",
    phoneNumber: "",
    message: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post(
        'http://localhost:5000/api/contact', // Replace with your backend API endpoint
        formData
      );
      console.log(response.data); // Assuming the response contains a success message
      // Do something after successful form submission (e.g., show success message)
    } catch (error) {
      console.error('Error submitting form:', error);
      // Handle error (e.g., show error message)
    }
  };

  return (
    <div className="mine-thunder-container-contact">
      <a href="https://www.minethunder.com">
        <div className="mine-thunder-Logo-logo-container">
          <img
            src={MineThunderlogo}
            alt="MineThunderlogo"
            className="mine-thunderlogo-logo"
          />
        </div>
      </a>

      <div className="mine-thunder-container-text">
        <h1 id="mine-thunder-contactus">Contact Us</h1>
        <p className="mine-thunder-description">
          We welcome your inquiries. Please don't hesitate to reach out, and
          we'll be happy to assist you.
        </p>
        <div className="mine-thunder-form-wrapper">
          <form action="" method="POST">
            <div className="mine-thunder-form-row">
              <div className="mine-thunder-form-input-half" id="mine-thunder-form-input-half-1">
                <input
                  type="text"
                  className="mine-thunder-form-input"
                  placeholder="First Name"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mine-thunder-form-input-half" id="mine-thunder-form-input-half-2">
                <input
                  type="text"
                  className="mine-thunder-form-input"
                  id="lastname"
                  placeholder="Last Name"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="mine-thunder-form-row">
              <input
                type="text"
                className="mine-thunder-form-input-long"
                placeholder="Business Name"
                name="businessName"
                value={formData.businessName}
                onChange={handleInputChange}
              />
            </div>
            <div className="mine-thunder-form-row">
              <input
                 type="email" className="mine-thunder-form-input-long"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
            </div>
            <div className="mine-thunder-form-row">
              <div className="mine-thunder-form-input-half" id="mine-thunder-form-input-half-3">
                <input
                  type="text"
                  className="mine-thunder-form-input"
                  placeholder="Subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mine-thunder-form-input-half" id="mine-thunder-form-input-half-4">
                <input
                  type="number"
                  className="mine-thunder-form-input"
                  id="phonenumber"
                  placeholder="Phone Number"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="mine-thunder-message-container">
              <textarea
                id="mine-thunder-form-input-message"
                placeholder="Message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
              ></textarea>
            </div>
            <button className="mine-thunder-form-submit sent-icon" id="mine-thunder-sent" type="submit">
              Send
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
